import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Select,
} from "@chakra-ui/react";
import React from "react";
import ReactHtmlParser from "react-html-parser";
import Download from "../../assets/images/download.svg";
import Mail from "../../commomComponents/mail";
import { InvestorCorner } from "../../constants/Constants";
import { IMAGE_URL, SITE_ID } from "../../services/apiConstants";
import getInvestorCornerDetails from "../../services/request/investor";
import { downloadPdf } from "../../utils/downloadPdf";
import styles from "../InvestorCorner/Investor.module.css";
import sortObject from "../../utils/sortingObject";
import moment from "moment";
import "./investorCorner.css";
import BannerWithHeading from "../../commomComponents/bannerWithHeading";
import SebiDocument from "../../services/request/sebidoc";
import Loader from "../../commomComponents/Loader";
import LinkVisual from "../../assets/images/link-visual.svg";
import AIFDisclosure from "../../assets/pdf/AIFDisclosureRevised.pdf";
import SeoHelmet from "../../commomComponents/seoHelmet";

const presentationArray = [];
const factSheetArray = [];
let investorGrievanceArray = [];
class Investor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lessContent: [],
      moreContent: [],
      Presentations: [],
      title: "VIEW MORE",
      titleFactsheet: "VIEW MORE",
      lessContentFactSheet: [],
      factSheet: [],
      moreContentFactSheet: [],
      faqData: [],
      forms: [],
      disclosures: [],
      sebi: [],
      banner: [],
      investorGrievance: [],
      titleInvestorGrievance: "VIEW MORE",
      lessContentInvestorGrievance: [],
      moreContentInvestorGrievance: [],
      years: [],
      selectedYear: "",
      investorGrievanceViewMore: false,
      loadMore: false,
      isLoading: true,
      activeTab: "PMS", //Default
    };
    this.myRef = React.createRef();
    this.myRef2 = React.createRef();
    this.myRef3 = React.createRef();
  }
  componentWillMount = () => {
    document.title =
      "Investment Strategies, Insights & Analysis - Investor's Corner";
    this.setState({
      lessContent: [],
      moreContent: [],
      Presentations: [],
      title: "VIEW MORE",
      titleFactsheet: "VIEW MORE",
      lessContentFactSheet: [],
      factSheet: [],
      moreContentFactSheet: [],
      faqData: [],
      forms: [],
      disclosures: [],
      sebi: [],
      banner: [],
      investorGrievance: [],
      titleInvestorGrievance: "VIEW MORE",
      lessContentInvestorGrievance: [],
      moreContentInvestorGrievance: [],
      years: [],
      selectedYear: "",
      investorGrievanceViewMore: false,
      loadMore: false,
      isLoading: true,
    });
    this.callAllApis();
  };

  callAllApis = () => {
    const Investor = getInvestorCornerDetails();
    const SebiDoc = SebiDocument();

    Investor.then((data) => {
      this.setState({
        lessContent: data.data.presentations,
        Presentations: data.data.presentations,
        moreContent: data.data.presentations,
        disclosures: data.data.disclosures,
        factSheet: data.data.factsheets,
        isLoading: false,
      });
      // data.data.presentations.map((pres, index) => {
      //   if (index < 7) {
      //     presentationArray.push(pres);
      //   }
      //   this.setState({
      //     lessContent: presentationArray,
      //     Presentations: presentationArray,
      //     moreContent: data.data.presentations,
      //     disclosures: data.data.disclosures,
      //     factSheet: data.data.factsheets,
      //     isLoading: false,
      //   });
      // });
      if (data.data.presentations.length <= 6) {
        this.setState({ title: null });
      }
      // data.data.factsheets.map((pres) => {
      //   factSheetArray.push(pres);
      // });

      investorGrievanceArray = data.data.investorGrievance;

      this.setState({
        lessContentInvestorGrievance: investorGrievanceArray,
        investorGrievance: investorGrievanceArray,
        moreContentInvestorGrievance: investorGrievanceArray,
      });
      this.getUniqueYears();
      this.setState({
        faqData: data.data.faq,
        forms: data.data.forms,
        banner: data.data.banner,
      });
    });

    SebiDoc.then((data) => {
      this.setState({ sebi: data.data.sebi });
    });
  };
  changeContent3 = () => {
    const {
      lessContentInvestorGrievance,
      moreContentInvestorGrievance,
      titleInvestorGrievance,
    } = this.state;

    if (titleInvestorGrievance === "VIEW MORE") {
      this.setState({
        titleInvestorGrievance: "VIEW LESS",
        investorGrievance: moreContentInvestorGrievance,
      });
    } else {
      window.scrollTo(0, this.myRef3.current.offsetTop);
      this.setState({
        titleInvestorGrievance: "VIEW MORE",
        investorGrievance: lessContentInvestorGrievance,
      });
    }
  };
  changeContent = () => {
    const { lessContent, moreContent, title } = this.state;

    if (title === "VIEW MORE") {
      this.setState({
        title: "VIEW LESS",
        Presentations: moreContent,
      });
    } else {
      window.scrollTo(0, this.myRef.current.offsetTop);
      this.setState({
        title: "VIEW MORE",
        Presentations: lessContent,
      });
    }
  };

  getUniqueYears = () => {
    const year = investorGrievanceArray.map((invest) => {
      if (invest.year !== undefined) {
        return invest.year;
      }
    });

    var arr = year.filter(function (value, index, self) {
      return self.indexOf(value) === index;
    });

    arr.splice(0, 1);
    arr.sort(function (a, b) {
      return ("" + a.attr).localeCompare(b.attr);
    });
    // chronological order
    arr.sort((a, b) => {
      // Extract the years from the strings
      const yearA = parseInt(a.substring(0, 4), 10);
      const yearB = parseInt(b.substring(0, 4), 10);

      // Compare the years in descending order
      if (yearA === yearB) {
        // If the years are the same, compare the second part (YY) in descending order
        const yyA = parseInt(a.substring(5), 10);
        const yyB = parseInt(b.substring(5), 10);
        return yyB - yyA;
      }

      return yearB - yearA;
    });

    this.setState({ years: arr });
    this.getSortedYears(arr[0]);
  };
  onChange = (e) => {
    this.getSortedYears(e.target.value);
  };
  getSortedYears = (value) => {
    var filteredList = investorGrievanceArray.filter((invest) => {
      if (invest.year !== undefined && invest.year == value) {
        return invest;
      }
    });

    this.setState({
      lessContentInvestorGrievance: filteredList,
      investorGrievance: filteredList,
      moreContentInvestorGrievance: filteredList,
    });
  };
  componentDidMount() {
    // Check if there's a hash in the URL and scroll to the corresponding section
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }

  setActiveTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  render() {
    const {
      Presentations,
      factSheet,
      titleInvestorGrievance,
      years,
      investorGrievance,
      title,
      titleFactsheet,
      faqData,
      forms,
      disclosures,
      sebi,
      banner,
      isLoading,
    } = this.state;
    function scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);

      if (element) {
        const headerHeight = 400;
        const offset = headerHeight;

        window.scrollTo({
          top: offset,
          behavior: "smooth", // For smooth scrolling
        });
      }
    }
    function scrollToSection1(sectionId) {
      const element = document.getElementById(sectionId);

      if (element) {
        const headerHeight = 200;
        const offset =
          element.getBoundingClientRect().top + window.scrollY - headerHeight;

        window.scrollTo({
          top: offset,
          behavior: "smooth", // For smooth scrolling
        });
      }
    }

    const { activeTab } = this.state;

    console.log("STATE ", this.state);
    return (
      <div>
        <>
          <SeoHelmet
            title="Investment Strategies, Insights & Analysis - Investor's Corner"
            description="Discover expert investment, strategies, insights and analysis at ICICI Pru Alternates' Investor's Corner. Stay ahead with our latest market updates and strategies."
            url="https://www.iciciprualternates.com/investors-corner"
          />
          <Mail />
          <div className={styles.slides}>
            {/* {banner.length > 0 && banner[0] ? (
              <BannerWithHeading
                bannerImage={IMAGE_URL + banner[0].image + SITE_ID}
                heading={banner[0].title}
              />
            ) : null} */}
            <div className={styles.imageBanner}>
              {banner.length > 0 && banner[0] ? (
                <>
                  <img src={IMAGE_URL + banner[0].image + SITE_ID} alt="" />
                </>
              ) : null}
            </div>
            <ul className={styles.button}>
              <li>
                <a
                  style={{ cursor: "pointer" }}
                  className={styles.btn}
                  onClick={() => scrollToSection("Presentation")}
                >
                  {InvestorCorner.Presentation}
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: "pointer" }}
                  className={styles.btn}
                  onClick={() => scrollToSection1("Factsheets")}
                >
                  {InvestorCorner.Factsheets}
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: "pointer" }}
                  className={styles.btn}
                  onClick={() => scrollToSection1("Forms")}
                >
                  {InvestorCorner.Forms}
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: "pointer" }}
                  className={styles.btn}
                  onClick={() => scrollToSection1("Disclosure")}
                >
                  {InvestorCorner.Regulatory_Disclosures}
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: "pointer" }}
                  className={styles.btn}
                  onClick={() => scrollToSection1("InvestorGrievance")}
                >
                  {InvestorCorner.Grievance_Disclosure}
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: "pointer" }}
                  className={styles.btn}
                  onClick={() => scrollToSection1("FAQ")}
                >
                  {InvestorCorner.FAQ}
                </a>
              </li>
            </ul>
          </div>
          {isLoading ? (
            <Loader />
          ) : (
            <section
              className={styles.container}
              ref={this.myRef}
              id="Presentation"
            >
              <div>
                <p className={`${styles.heading} ${styles.marginTop}`}>
                  {InvestorCorner.Presentation}
                </p>
                <p className={styles.para}>
                  {InvestorCorner.Download_Presentation}
                </p>
                <div
                  style={{
                    height: "300px",
                    overflow: "hidden",
                    overflowY: "scroll",
                  }}
                >
                  {Presentations.length > 0
                    ? sortObject(Presentations, "id").map((data) => {
                        return (
                          <div className={styles.Presentations}>
                            <div className={styles.presentationTitle}>
                              {data.title}
                              <span className={styles.updatedDate}>
                                Updated on:
                                {moment(data.updatedOn).format("MMMM YYYY")}
                              </span>
                            </div>
                            {data.file ? (
                              <button
                                onClick={() => {
                                  window.dataLayer = window.dataLayer || [];
                                  window.dataLayer.push({
                                    event: "PMSpresentation_Download",
                                    inquiryType: "",
                                    buttonName: "Presentations",
                                    email: "", // Encrypted email of the User using SHA-256 encryption
                                    contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                                    clientID: "",
                                    queryMessage: "",
                                    state: "",
                                    pageSection: "",
                                    Category: data.title,
                                    FAQ: "",
                                  });
                                  downloadPdf(
                                    IMAGE_URL +
                                      data?.file?.item[0]?.key +
                                      SITE_ID,
                                    data.file?.item[0]?.value.split("/").pop()
                                  );
                                }}
                                className={styles.download}
                              >
                                <img src={Download} alt="" loading="lazy" />
                              </button>
                            ) : null}
                          </div>
                        );
                      })
                    : null}
                </div>
              </div>
            </section>
          )}

          <section
            className={styles.sections}
            ref={this.myRef2}
            id="Factsheets"
          >
            <div className={styles.container}>
              <p className={styles.heading}>{InvestorCorner.Factsheets}</p>
              <p className={styles.para}>
                {InvestorCorner.Download_Factsheets}
              </p>
              <div
                style={{
                  height: "300px",
                  overflow: "hidden",
                  overflowY: "scroll",
                }}
                className={styles.customScrollbar}
              >
                {factSheet.length > 0
                  ? sortObject(factSheet, "id").map((data) => {
                      return (
                        <div className={styles.Presentations}>
                          <div className={styles.presentationTitle}>
                            {data.title}
                            <span className={styles.updatedDate}>
                              Updated on:
                              {moment(data.updatedOn).format("MMMM YYYY")}
                            </span>
                          </div>
                          {data.file ? (
                            <button
                              onClick={() => {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                  event: "PMSfactsheet_download",
                                  inquiryType: "",
                                  buttonName: "Factsheet",
                                  email: "", // Encrypted email of the User using SHA-256 encryption
                                  contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                                  clientID: "",
                                  queryMessage: "",
                                  state: "",
                                  pageSection: "",
                                  Category: data.title,
                                  FAQ: "",
                                });
                                downloadPdf(
                                  IMAGE_URL +
                                    data?.file?.item[0]?.key +
                                    SITE_ID,
                                  data.file?.item[0]?.value.split("/").pop()
                                );
                              }}
                            >
                              <img src={Download} alt="" loading="lazy" />
                            </button>
                          ) : null}
                        </div>
                      );
                    })
                  : null}
                {}
              </div>
            </div>
          </section>
          <section className={styles.sections} id="Forms">
            <div className={styles.container}>
              <p className={styles.heading}>{InvestorCorner.Forms}</p>
              <p className={styles.para}>{InvestorCorner.Download_Forms}</p>

              {/* Tab Buttons */}
              <div className={styles.tabsContainer}>
                <button
                  className={`${styles.tabButton} ${
                    activeTab === "PMS" ? styles.btnActive : ""
                  }`}
                  onClick={() => this.setActiveTab("PMS")}
                >
                  PMS
                </button>
                <button
                  className={`${styles.tabButton} ${
                    activeTab === "AIF" ? styles.btnActive : ""
                  }`}
                  onClick={() => this.setActiveTab("AIF")}
                >
                  AIF
                </button>
              </div>

              <div
                style={{
                  height: "300px",
                  overflow: "hidden",
                  overflowY: "scroll",
                }}
                className={styles.customScrollbar}
                id="RegulatoryDisclosure"
              >
                {activeTab === "PMS" ? (
                  <>
                    {forms.length > 0
                      ? sortObject(forms, "id")
                          .filter((data) => !data.title.includes("AIF"))
                          .map((data) => {
                            return (
                              <div className={styles.Presentations}>
                                <div className={styles.presentationTitle}>
                                  {data.title}
                                </div>
                                {data.file ? (
                                  <button
                                    onClick={() => {
                                      window.dataLayer = window.dataLayer || [];
                                      window.dataLayer.push({
                                        event: "form_download",
                                        inquiryType: "",
                                        buttonName: "",
                                        email: "", // Encrypted email of the User using SHA-256 encryption
                                        contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                                        clientID: "",
                                        queryMessage: "",
                                        state: "",
                                        pageSection: "Forms",
                                        Category: data.title,
                                        FAQ: "",
                                      });
                                      downloadPdf(
                                        IMAGE_URL +
                                          data?.file?.item[0]?.key +
                                          SITE_ID,
                                        data.file?.item[0]?.value
                                          .split("/")
                                          .pop()
                                      );
                                    }}
                                  >
                                    <img src={Download} alt="" loading="lazy" />
                                  </button>
                                ) : null}
                              </div>
                            );
                          })
                      : null}
                  </>
                ) : (
                  <>
                    {forms.length > 0
                      ? sortObject(forms, "id")
                          .filter((data) => data.title.includes("AIF"))
                          .map((data) => {
                            return (
                              <div className={styles.Presentations}>
                                <div className={styles.presentationTitle}>
                                  {data.title}
                                </div>
                                {data.file ? (
                                  <button
                                    onClick={() => {
                                      window.dataLayer = window.dataLayer || [];
                                      window.dataLayer.push({
                                        event: "form_download",
                                        inquiryType: "",
                                        buttonName: "",
                                        email: "", // Encrypted email of the User using SHA-256 encryption
                                        contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                                        clientID: "",
                                        queryMessage: "",
                                        state: "",
                                        pageSection: "Forms",
                                        Category: data.title,
                                        FAQ: "",
                                      });
                                      downloadPdf(
                                        IMAGE_URL +
                                          data?.file?.item[0]?.key +
                                          SITE_ID,
                                        data.file?.item[0]?.value
                                          .split("/")
                                          .pop()
                                      );
                                    }}
                                  >
                                    <img src={Download} alt="" loading="lazy" />
                                  </button>
                                ) : null}
                              </div>
                            );
                          })
                      : null}
                  </>
                )}
                {}
              </div>
            </div>

            <section
              className={styles.sections}
              ref={this.myRef2}
              id="Disclosure"
            >
              <div className={styles.container}>
                <p className={styles.heading}>
                  {InvestorCorner.Regulatory_Disclosures}
                </p>
                <p className={styles.para}>
                  {InvestorCorner.Download_Disclosure}
                </p>
                <div
                  style={{
                    height: "300px",
                    overflow: "hidden",
                    overflowY: "scroll",
                  }}
                  className={styles.customScrollbar}
                >
                  {disclosures.length > 0
                    ? sortObject(disclosures, "id").map((data) => {
                        return (
                          <div className={styles.Presentations}>
                            <div className={styles.presentationTitle}>
                              {data.title}
                              {/* <span className={styles.updatedDate}>
                                Updated on:
                                {moment(data.updatedOn).format("MMMM YYYY")}
                              </span> */}
                            </div>
                            {data.file ? (
                              <button
                                onClick={() => {
                                  window.dataLayer = window.dataLayer || [];
                                  window.dataLayer.push({
                                    event: "regulatoryDisclosure_download",
                                    inquiryType: "",
                                    buttonName: "",
                                    email: "", // Encrypted email of the User using SHA-256 encryption
                                    contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                                    clientID: "",
                                    queryMessage: "",
                                    state: "",
                                    pageSection: "Regulatory Disclosures",
                                    Category: data.title,
                                    FAQ: "",
                                  });
                                  downloadPdf(
                                    IMAGE_URL +
                                      data?.file?.item[0]?.key +
                                      SITE_ID,
                                    data.file?.item[0]?.value.split("/").pop()
                                  );
                                }}
                              >
                                <img src={Download} alt="" loading="lazy" />
                              </button>
                            ) : null}
                          </div>
                        );
                      })
                    : null}
                  {}
                </div>
              </div>
            </section>
            <section
              className={styles.sections}
              ref={this.myRef3}
              id="InvestorGrievance"
            >
              <div className={styles.container}>
                <p className={styles.heading}>
                  {InvestorCorner.Grievance_Disclosure}
                </p>
                <p className={styles.para}>
                  {InvestorCorner.Investor_Grievance_subtitle}
                </p>
                <div
                  style={{
                    height: "300px",
                    overflow: "hidden",
                    overflowY: "scroll",
                  }}
                  className={styles.customScrollbar}
                >
                  <select
                    onChange={(e) => this.onChange(e)}
                    style={{ padding: "8px", fontSize: "18px" }}
                  >
                    {years.map((year, index) => (
                      <option key={index} value={year}>
                        FY {year}
                      </option>
                    ))}
                  </select>

                  {investorGrievance.length > 0
                    ? sortObject(investorGrievance, "id").map((data) => {
                        return (
                          <div className={styles.Presentations}>
                            <div className={styles.presentationTitle}>
                              {data.title}
                            </div>
                            {data.file ? (
                              <button
                                onClick={() => {
                                  window.dataLayer = window.dataLayer || [];
                                  window.dataLayer.push({
                                    event: "griveranceDisclosure_download",
                                    inquiryType: "",
                                    buttonName: "",
                                    email: "", // Encrypted email of the User using SHA-256 encryption
                                    contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                                    clientID: "",
                                    queryMessage: "",
                                    state: "",
                                    pageSection: "Grievance Disclosure",
                                    Category: data.title,
                                    FAQ: "",
                                  });
                                  downloadPdf(
                                    IMAGE_URL +
                                      data?.file?.item[0]?.key +
                                      SITE_ID,
                                    data.file?.item[0]?.value.split("/").pop()
                                  );
                                }}
                              >
                                <img src={Download} alt="" loading="lazy" />
                              </button>
                            ) : null}
                          </div>
                        );
                      })
                    : null}
                  {}
                </div>
              </div>
            </section>
            {isLoading && <div style={{ height: "1000px" }}></div>}
            <section className={styles.sectionOne} id="sebi">
              <div
                className={styles.container}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <p className={styles.heading}>
                  {InvestorCorner.Alternate_Dispute_Resolution_Circular}
                </p>

                <div>
                  {sebi &&
                    sebi.length &&
                    sebi.map((data) => {
                      return (
                        <div>
                          {data.file ? (
                            <button
                              onClick={() =>
                                downloadPdf(
                                  IMAGE_URL +
                                    data?.file?.item[0]?.key +
                                    SITE_ID,
                                  data.file?.item[0]?.value.split("/").pop()
                                )
                              }
                            >
                              <img
                                src={Download}
                                className={styles.marginLeft}
                                alt=""
                                loading="lazy"
                              />
                            </button>
                          ) : null}
                        </div>
                      );
                    })}
                </div>
              </div>
            </section>

            <section className={styles.sectionsBetween} id="sebi">
              <div
                className={styles.container}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <p className={styles.heading_ODR_SOP}>
                  {InvestorCorner.Link_for_login_to_ODR}
                </p>

                <div>
                  <a href="https://smartodr.in/login" target="_blank">
                    <button
                      style={{ marginBottom: "1px" }}
                      onClick={() => {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                          event: "odrLink_click",
                          inquiryType: "",
                          buttonName: "",
                          email: "", // Encrypted email of the User using SHA-256 encryption
                          contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                          clientID: "",
                          queryMessage: "",
                          state: "",
                          pageSection: "Link for login to ODR",
                          Category: "",
                          FAQ: "",
                        });
                      }}
                    >
                      <img
                        src={LinkVisual}
                        className={styles.marginLeft}
                        alt=""
                        loading="lazy"
                      />
                    </button>
                  </a>
                </div>
              </div>
              <div>
                <a
                  href="https://smartodr.in/login"
                  target="_blank"
                  onClick={() => {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: "odrLink_click",
                      inquiryType: "",
                      buttonName: "",
                      email: "", // Encrypted email of the User using SHA-256 encryption
                      contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                      clientID: "",
                      queryMessage: "",
                      state: "",
                      pageSection: "Link for login to ODR",
                      Category: "",
                      FAQ: "",
                    });
                  }}
                >
                  <span
                    style={{
                      fontSize: "22px",
                      color: "#606060",
                      textDecoration: "underline",
                    }}
                  >
                    https://smartodr.in/login
                  </span>
                </a>
              </div>
            </section>

            <section className={styles.sectionsBetween} id="sebi">
              <div
                className={styles.container}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <p className={styles.heading_ODR_SOP}>
                  {InvestorCorner.SOP_Version}
                </p>
              </div>
              <div
                className={styles.container}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <p className={styles.heading}>{InvestorCorner.SOP_SUB_TITLE}</p>
                <div>
                  <a
                    href="https://www.iciciprupms.com/docs/default-source/default-document-library/common-sop-for-centralized-demise-information-v1-2-1.pdf"
                    target="_blank"
                  >
                    <button style={{ marginBottom: "14px" }}>
                      <img
                        src={Download}
                        className={styles.marginLeft}
                        alt=""
                        loading="lazy"
                      />
                    </button>
                  </a>
                </div>
              </div>
            </section>

            <section className={styles.sections} id="FAQ">
              <div className={styles.containerEnd}>
                <p className={styles.heading}>{InvestorCorner.Investors_Faq}</p>
                <p className={styles.para}>
                  {InvestorCorner.Frequently_Questions}
                </p>
                <Accordion allowToggle isfocusable={true}>
                  {sortObject(faqData, "id")
                    .filter((data) => data.id !== 7)
                    .map((data) => {
                      return (
                        <AccordionItem>
                          {({ isExpanded }) => (
                            <>
                              <h2>
                                <AccordionButton
                                  _expanded={{ bg: "#97291e", color: "white" }}
                                  _hover={{ bg: "#97291e", color: "white" }}
                                  padding={20}
                                  fontSize={20}
                                  backgroundColor="white"
                                  color="#97291e"
                                  border="1px solid #97291e"
                                  fontFamily="Mulish, sans-serif"
                                  onClick={() => {
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                      event: "faq_view",
                                      inquiryType: "",
                                      buttonName: "",
                                      email: "", // Encrypted email of the User using SHA-256 encryption
                                      contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                                      clientID: "",
                                      queryMessage: "",
                                      state: "",
                                      pageSection: "Investors FAQ",
                                      Category: "",
                                      FAQ: data.question,
                                    });
                                  }}
                                >
                                  <Box
                                    border={"transparent"}
                                    // width={1300}
                                    textAlign="left"
                                    paddingLeft="3%"
                                    fontWeight={400}
                                    className={styles.boxWidth}
                                  >
                                    {ReactHtmlParser(data.question)}
                                  </Box>
                                  {isExpanded ? (
                                    <span className="crossPlus">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                      >
                                        <g
                                          fill="none"
                                          fill-rule="evenodd"
                                          opacity=".8"
                                        >
                                          <g>
                                            <path
                                              d="M0 0L24 0 24 24 0 24z"
                                              transform="translate(-1298 -5774) translate(1296 5772)"
                                            ></path>
                                            <path
                                              class="accord-arr"
                                              fill="white"
                                              fill-rule="nonzero"
                                              d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                                              transform="translate(-1298 -5774) translate(1296 5772)"
                                            ></path>
                                          </g>
                                        </g>
                                      </svg>
                                    </span>
                                  ) : (
                                    <span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                      >
                                        <g
                                          fill="none"
                                          fill-rule="evenodd"
                                          opacity="1"
                                        >
                                          <g>
                                            <path
                                              d="M0 0L24 0 24 24 0 24z"
                                              transform="translate(-1298 -5774) translate(1296 5772)"
                                            ></path>
                                            <path
                                              class="accord-arr"
                                              fill="#c9b16d"
                                              fill-rule="nonzero"
                                              d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                                              transform="translate(-1298 -5774) translate(1296 5772)"
                                            ></path>
                                          </g>
                                        </g>
                                      </svg>
                                    </span>
                                  )}
                                </AccordionButton>
                              </h2>
                              <div className={styles.faqsection}>
                                <AccordionPanel>
                                  <p className={styles.expandedContent}>
                                    {ReactHtmlParser(data.answer)}
                                  </p>
                                </AccordionPanel>
                              </div>
                            </>
                          )}
                        </AccordionItem>
                      );
                    })}
                </Accordion>
              </div>
            </section>
          </section>
        </>
      </div>
    );
  }
}
export default Investor;
